module.exports = __webpack_public_path__ + "static/media/i-can-see-for-years.f7458a1e.mp3";